import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropArea", "fileInput", "count"];

  connect() {
    this.fileList = [];
    this.element.addEventListener("dragenter", this.showDropText.bind(this));
    this.element.addEventListener("dragleave", this.hideDropText.bind(this));
    this.element.addEventListener("dragover", this.preventDragDefault.bind(this));
    this.element.addEventListener("drop", this.handleDrop.bind(this));
    this.fileInputTarget.addEventListener("change", this.handleDrop.bind(this));
  }

  showDropText(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.add("border-dashed", "border-2", "border-red-800");
  }

  hideDropText(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.remove("border-dashed", "border-2", "border-red-800");
  }

  preventDragDefault(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.add("border-dashed", "border-2", "border-red-800");
  }

  handleDrop(event) {
    event.preventDefault();
    const files = event.type === "drop" ? event.dataTransfer.files : event.target.files;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.fileList.push(files[i]);
      }
      this.updateFileList();
      this.hideDropText(event);
    }
  }

  removeFile(event) {
    let id = event.target.dataset.documentPosition || event.target.parentElement.dataset.documentPosition || event.target.parentElement.parentElement.dataset.documentPosition
    this.fileList.splice(id, 1);
    const fileListElement = this.element.querySelector(`.file-${id}`);
    fileListElement.remove();
    this.updateFileList();
  }

  updateFileList() {
    const fileListElement = this.element.querySelector("Template").content.querySelector("#file-list")
    fileListElement.innerHTML = "";
    this.fileList.forEach((file, index) => {
      const listItem = document.createElement("span");
      listItem.classList.add("text-sm", "text-slate-400", "py-1", "flex", "gap-2", `file-${index}`);
      listItem.innerHTML = `
        <i class="fa fa-solid fa-trash text-slate-400 hover:text-red-600" data-document-position=${index} data-action="click->drop-attachments#removeFile:stop:prevent"></i>
        ${file.name}
      `;
      fileListElement.appendChild(listItem);
    });

    const newFileList = new DataTransfer();
    this.fileList.forEach((file) => {
      newFileList.items.add(file);
    });
    this.fileInputTarget.files = newFileList.files;
    this.countTarget.innerText = parseInt(this.countTarget.dataset.count) + this.fileList.length
  }
}

